export default "__VITE_ASSET__NGN$Lz3x__"